module.exports = __webpack_public_path__ + "2d82fb26288ac31fe73f1878be0b612e.pdf";